import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';
import NRReactGridPrintable from '../NRReactGrid/NRReactGridPrintable';
import { valueOrFallback } from './NRAssetSummaryPrintable.utils';

export const SectionTable = ({ columns, rows, emptyLabel = 'No data available.' }) => (
  <TableContainer component={Paper} elevation={0} sx={{ border: theme => `1px solid ${theme.palette.divider}`, p: 2 }}>
    {rows.length === 0 ? (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {emptyLabel}
        </Typography>
      </Box>
    ) : (
      <NRReactGridPrintable
        columns={columns.map(column => ({
          name: column.key,
          title: column.label
        }))}
        rows={rows.map(row =>
          columns.reduce((acc, column) => {
            acc[column.key] = valueOrFallback(row[column.key]);
            return acc;
          }, {})
        )}
      />
    )}
  </TableContainer>
);

export const CrackedCredentialsCards = ({ credentials }) => (
  <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>
    {credentials.length === 0 ? (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        No cracked credentials found.
      </Typography>
    ) : (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {credentials.map((credential, index) => {
          const isUserAccount = credential?.type === 'User Account';
          return (
            <Box
              key={`cracked-credential-${index}`}
              sx={{
                p: 2,
                border: theme => `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                backgroundColor: 'background.paper'
              }}
            >
              <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 180px', minWidth: 0 }}>
                  <Typography variant="body1" color="text.secondary">
                    Type
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {valueOrFallback(credential?.type)}
                  </Typography>
                </Box>
                {isUserAccount ? (
                  <Box sx={{ flex: '1 1 180px', minWidth: 0 }}>
                    <Typography variant="body1" color="text.secondary">
                      User Name
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                      {valueOrFallback(credential?.userName)}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ flex: '1 1 220px', minWidth: 0 }}>
                    <Typography variant="body1" color="text.secondary">
                      Hash
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                      {valueOrFallback(credential?.hash)}
                    </Typography>
                  </Box>
                )}
                <Box sx={{ flex: '1 1 100%', minWidth: 0 }}>
                  <Typography variant="body1" color="text.secondary">
                    File Path
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                    {valueOrFallback(credential?.filePath)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    )}
  </Paper>
);
